module.exports = __webpack_public_path__ + "img/title-body.31115f7a.svg";